import { Routes } from '@dtx-company/true-common/src/constants/routes'
import {
  TOP_NAV_BANNER_HEIGHT,
  TOP_NAV_BANNER_HEIGHT_MOBILE
} from '../TopNavBannerWrapper/TopNavBannerWrapper'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useMediaQuery } from '@dtx-company/true-common/src/hooks/useMediaQuery'
import { useMemo } from 'react'
import { useRouter } from 'next/router'
import { useTrialConfig } from '@app/common/src/hooks/useTrialConfig/useTrialConfig'
import events from '@dtx-company/inter-app/src/event-tracking/events/homepage'

export interface ProUpsellBannerExperimentData {
  displayProUpsellTopNavBanner: boolean
  handleClick: () => void
  bannerHeight: number
}

export const useProUpsellBannerState = (): ProUpsellBannerExperimentData => {
  const router = useRouter()
  const { hasOperation } = useAuthState()
  const isSideNavBP = useMediaQuery(`(max-width: 831px)`)
  const bannerHeight = isSideNavBP ? TOP_NAV_BANNER_HEIGHT_MOBILE : TOP_NAV_BANNER_HEIGHT
  const trialConfig = useTrialConfig()

  const displayProUpsellTopNavBanner = useMemo(() => {
    const isCodeManagementOrFoldersPage = [Routes.FOLDERS, Routes.CODES, Routes.ASSETS].some(
      val => router.pathname === val
    )
    return (
      isCodeManagementOrFoldersPage &&
      hasOperation('view:code_management_pro_upsell_banner') &&
      !trialConfig?.inTrial
    )
  }, [hasOperation, trialConfig?.inTrial, router.pathname])

  const handleClick = (): void => {
    events.userClickedProUpsellTopNavBanner()
  }

  return {
    displayProUpsellTopNavBanner,
    handleClick,
    bannerHeight
  }
}
